import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { useEffect, useRef, useState } from 'react';
import { MdOutlineAod } from 'react-icons/md';
// import { useQueryClient } from 'react-query';
import { SurvivorsConversationStore } from './../../modules/datastores/useGetSurvivorsConversation';
import { useGenerateOtpRequest, useGetWebChatSMSNumberStatus, useOptInSMSRequest } from './../../modules/datastores/useWaitViaSMS';
import { uiStore } from '../../modules/datastores/useUiStore';
import { useLocation } from 'react-location';
import ReactPhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { TextField } from '@mui/material';
import type { ISMSOptInProcessActive } from '../../modules/algebra/waiting-room';

interface IWaitViaSMSProps {
  messaging_service_key?: string;
  task_sid?: string;
  wait_via_sms_data?: ISMSOptInProcessActive;
  isSMSOptInProcessActive?: boolean
}

const WaitViaSMS: React.FC<IWaitViaSMSProps> = ({ messaging_service_key, task_sid, wait_via_sms_data, isSMSOptInProcessActive }) => {
  const [wantToWaitViaSMS, setWantToWaitViaSMS] = useState<boolean>(isSMSOptInProcessActive ? true : false);
  const [optedSMSWaitRequest, setSMSOptedWaitRequest] = useState<boolean>(false);
  const [phoneNumber, setPhoneNumber] = useState<string>(isSMSOptInProcessActive ? wait_via_sms_data?.phone_number || "+1" : '+1');
  const { mutateAsync: mutateOptInRequest, isLoading: submittingOtpInProgress } = useOptInSMSRequest();
  const { mutateAsync: mutateGenerateOtpRequest, isLoading: getOtpInProgress } = useGenerateOtpRequest();
  const [otpNumber, setOtpNumber] = useState<string>()
  const [isOtpSent, setIsOtpSent] = useState(isSMSOptInProcessActive ? true : false);
  const location = useLocation();
  const [timer, setTimer] = useState(0);
  const phoneInputRef = useRef<HTMLInputElement>(null);
  const [requestForEdit, setRequestForEdit] = useState(false);

  const { data: smsOptStatus, isSuccess, isLoading, isError } = useGetWebChatSMSNumberStatus(task_sid, optedSMSWaitRequest, messaging_service_key);
  const wantsToOptInSMS = () => setWantToWaitViaSMS(true);
  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
  };
  const setTimerForAttempt = (attempt: number) => {
    let timerDuration;
    const MINUTE = 60;
    switch (attempt) {
      case 0:
        timerDuration = 5 * MINUTE;
        break;
      case 1:
        timerDuration = 10 * MINUTE;
        break;
      case 2:
        timerDuration = 15 * MINUTE;
        break;
      case 3:
        timerDuration = 30 * MINUTE;
        break;
      default:
        return;
    }
    if (attempt <= 3) {
      setTimer(timerDuration);
    }
  };


  /**
   *!Post Request to OptIn SMS
   */
  const optInRequest = () => {
    mutateOptInRequest(
      { messaging_service_key, task_sid, phone_number: phoneNumber, otp: otpNumber as unknown as number },
      {
        onSuccess: () => {
          setSMSOptedWaitRequest(true);
          SurvivorsConversationStore.waitingViaSMS(true);
        },
        onError: (error: any) => {
          uiStore.setErrorMessage(error.errors.toString());
        },
      }
    );
  };
  /**
   *!Post Request to Opt Out SMS
   */

  /**
 *!Post Request to Get the OTP 
 */
  const getOtp = () => {
    mutateGenerateOtpRequest(
      { messaging_service_key, task_sid, phone_number: phoneNumber, resend_otp: isOtpSent ? true : false },
      {
        onSuccess: (data: any) => {
          setIsOtpSent(true)
          setTimerForAttempt(data?.attempt)
        },
        onError: (error: any) => {
          uiStore.setErrorMessage(error.errors.toString());
        },
      }
    );
  };
  /**
   *!Post Request to Opt Out SMS
   */
  const isInvalidPhoneNumber = (): boolean => {
    return /^(\+1)\(?(\d{3})\)?[-.]?(\d{3})[-.]?(\d{4})(x\d{4})?$/.test(phoneNumber);
  };
  const handleFocusPhoneInput = () => {
    setIsOtpSent(false);
    setTimer(0);
    setRequestForEdit(true);
  };
  useEffect(() => {
    if (isSuccess && !isLoading && smsOptStatus && optedSMSWaitRequest) {
      location.history.replace('/redirect');
    }
  }, [isSuccess, isLoading, smsOptStatus, optedSMSWaitRequest]);

  useEffect(() => {
    let interval: any = null;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else if (timer === 0) {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [timer]);

  useEffect(() => {
    if (!isOtpSent && phoneInputRef.current && requestForEdit) {
      phoneInputRef.current?.focus();
      setRequestForEdit(false);
    }
  }, [requestForEdit]);
  return (
    <Box className="border-1 p-3 h-full">
      <div className=" flex flex-col gap-2">
        <div className="col-span-12 sm:col-span-12">
          <Typography variant="h1" className="text-base font-bold">
            <MdOutlineAod className="inline text-xl ml-5px" /> Wait Via SMS
          </Typography>
        </div>
        {/* {isSuccess && !isLoading && smsOptStatus && optedSMSWaitRequest && (
          <>
            <Typography variant="body1" className="text-base">
              You have successfully opted to waiting via SMS, you can now close the browser.
            </Typography>
            <Button className="button-primary mr-2 bg-color-change" onClick={() => optOutRequest()}>
              Opt Out Of Wait Via SMS
            </Button>
          </>
        )} */}
        {isLoading && (
          <>
            <Typography variant="body1" className="text-base">
              Connecting you to SMS waiting. Do not close the browser until this is complete.
            </Typography>
            <CircularProgress />
          </>
        )}
        {!optedSMSWaitRequest && wantToWaitViaSMS && (
          <>
            <Typography variant="body1" className="text-base">
              Just enter your number in the box below to opt into the SMS feature. You will also receive a one time OTP verification code. If the code gets entered incorrectly, you will have to wait before requesting a new one. When opted in, you will receive a message when it is time to log back on the chat. If you need more time, you will be able to defer your chat for a period of 15 minutes.
            </Typography>
            <div className=" grid grid-cols-12 gap-2 mt-3 items-end">
              <div className="col-span-7">
                <ReactPhoneInput
                  specialLabel={'Phone Number'}
                  country={'us'}
                  value={`+${phoneNumber?.replaceAll('+', '')}`}
                  countryCodeEditable={false}
                  containerClass="phone-input "
                  onlyCountries={['us']}
                  onChange={(val) => setPhoneNumber(`+${val?.replaceAll('+', '')}`)}
                  prefix="+"
                  disabled={isOtpSent}
                  inputProps={{
                    placeHolder: '(555) 555-1234',
                    ref: phoneInputRef
                  }}
                />
                {/* <p className="text-tc-5 text-xs">Enter your phone number with +1xxxxxxxxxx format</p> */}
                <div className="flex">
                  {isOtpSent && <Button className="button-link ml-0 block text-sm font-bold cursor-pointer mt-1 " onClick={handleFocusPhoneInput}>
                    Edit Number
                  </Button>}
                  <Button className="button-link ml-auto block text-sm font-bold cursor-pointer mt-1 " disabled={!isInvalidPhoneNumber() || timer > 0 || getOtpInProgress} onClick={getOtp}>
                    {getOtpInProgress ? "Getting Otp" : !isOtpSent ? 'Get Otp' : timer > 0 ? `Resend (${formatTime(timer)})` : `Resend`}
                  </Button>
                </div>
              </div>
              <div className="col-span-5">
                <TextField
                  id="otpCode"
                  className="rhs-input w-full"
                  label="Otp Code*"
                  value={otpNumber}
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ maxLength: 6 }}
                  onChange={(event) => setOtpNumber(`${event.target.value?.replace(/[^a-zA-Z0-9]/g, '')}`)}
                />
                <Button className="button-link ml-auto block text-sm font-bold cursor-pointer mt-1 " disabled={!(otpNumber?.length === 6) || submittingOtpInProgress} onClick={optInRequest}>
                  {submittingOtpInProgress ? "Submitting Code" : "Submit Code"}
                </Button>
              </div>
            </div>
          </>
        )}
        {optedSMSWaitRequest && isError && (
          <div className="mt-3">
            <Button
              className="underline text-blue-600 hover:text-blue-800 visited:text-purple-600"
              onClick={() => {
                setSMSOptedWaitRequest(false);
                setWantToWaitViaSMS(false);
              }}
            >
              The number you have supplied is formatted incorrectly, please check that you entered the number correctly and try again or you can continue waiting for online hotline services in the
              queue on your computer.
            </Button>
          </div>
        )}
        {!optedSMSWaitRequest && !wantToWaitViaSMS && (
          <>
            <Typography variant="body1" className="text-base">
              You now have the option to be notified via SMS (text message) about your position on the waitlist for the online hotline. Providing us with your phone number allows you to step away from
              your computer and receive a text message when you are next in line in the queue to chat with a support specialist
            </Typography>
            <div className="">
              <Button className="pl-0 text-base underline text-blue-600 hover:text-blue-800 visited:text-purple-600" onClick={() => wantsToOptInSMS()}>
                Enter Your Phone Number
              </Button>
            </div>
          </>
        )}
      </div>
    </Box>
  );
};

export default WaitViaSMS;
